import { Box, Link, Typography } from "@mui/material";
import { AppContext } from "../../store/genesys.context";
import React from "react";
import { getDataprotectionLink } from "../../utils/getDataprotectionLink";
import type { Brand } from "../../lib/ChatbotConfig";

const WelcomePageText = (): React.JSX.Element => {
  const {
    brand,
  }: {
    brand: Brand;
  } = React.useContext(AppContext);

  return (
    <Box
      sx={{
        padding: "0 20px 20px 20px",
        backgroundColor: (theme) =>
          theme.palette.widgetStyles.welcomePage.backgroundColor,
        p: 3,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "16px",
      }}
    >
      <Typography
        variant="h5"
        component={"p"}
        sx={{
          color: (theme) => theme.palette.widgetStyles.welcomePage.textColor,
          fontWeight: "bold",
        }}
      >
        Gleich geht’s los!
      </Typography>

      <Typography
        sx={{
          color: (theme) => theme.palette.widgetStyles.welcomePage.textColor,
          fontSize: "1.0625rem",
        }}
      >
        Chatte mit unserem Team Bildungsberatung und kläre deine Fragen zu
        unseren Kursen. Wir sind gerne für dich da.
      </Typography>

      <Link
        href={getDataprotectionLink(brand)}
        rel="noreferrer noopener"
        target="_blank"
        sx={{
          fontSize: "1.0625rem",
          borderColor: "white",
          p: 0,
          textTransform: "none",
          textDecoration: "underline",
          color: (theme) => theme.palette.widgetStyles.welcomePage.linkColor,

          "&:hover": {
            color: (theme) =>
              theme.palette.widgetStyles.welcomePage.linkHoverColor,
          },
        }}
      >
        Datenschutzerklärung
      </Link>
    </Box>
  );
};

export default WelcomePageText;
